/* Zeroo Health theme — interactions */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function accent() {
    var v = getComputedStyle(document.documentElement).getPropertyValue('--z-accent');
    return (v || '#c0dd59').trim();
  }

  ready(function () {
    var ACCENT = accent();

    /* ---------- FAQ accordion ---------- */
    document.querySelectorAll('[data-faq-item]').forEach(function (item) {
      var btn = item.querySelector('[data-faq-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = item.getAttribute('data-open') === 'true';
        item.setAttribute('data-open', open ? 'false' : 'true');
        var panel = item.querySelector('[data-faq-panel]');
        var sign = item.querySelector('[data-faq-sign]');
        if (panel) panel.style.display = open ? 'none' : 'block';
        if (sign) sign.textContent = open ? '+' : '–';
      });
    });

    /* ---------- Plan toggle (Subscribe & Save / One-time) ---------- */
    function initPlanForms(root) {
      (root || document).querySelectorAll('[data-plan-form]').forEach(function (form) {
        if (form.getAttribute('data-plan-ready') === 'true') return;
        form.setAttribute('data-plan-ready', 'true');

        var options = form.querySelectorAll('[data-plan-option]');
        var planInput = form.querySelector('[data-selling-plan-input]');
        var priceOut = form.querySelector('[data-plan-price]');
        var ctaPrice = form.querySelector('[data-cta-price]');

        function select(opt) {
          options.forEach(function (o) {
            var active = o === opt;
            o.setAttribute('data-active', active ? 'true' : 'false');
            o.style.borderColor = active ? ACCENT : 'rgba(255,255,255,0.1)';
            o.style.background = active ? 'rgba(192,221,89,0.08)' : 'transparent';
            var dot = o.querySelector('[data-radio]');
            if (dot) {
              dot.style.borderColor = active ? ACCENT : 'rgba(255,255,255,0.3)';
              dot.style.background = active ? 'radial-gradient(circle, ' + ACCENT + ' 42%, transparent 46%)' : 'transparent';
            }
          });
          if (planInput) planInput.value = opt.getAttribute('data-selling-plan') || '';
          var price = opt.getAttribute('data-price') || '';
          if (priceOut) priceOut.textContent = price;
          if (ctaPrice) ctaPrice.textContent = price;
        }

        options.forEach(function (opt) {
          opt.addEventListener('click', function () { select(opt); });
        });
        if (options.length) {
          var pre = form.querySelector('[data-plan-option][data-active="true"]') || options[0];
          select(pre);
        }
      });
    }

    initPlanForms(document);

    /* ---------- Cart discount code (apply via Ajax + inline validation) ---------- */
    function initDiscountForms(root) {
      (root || document).querySelectorAll('[data-discount-form]').forEach(function (wrap) {
        if (wrap.getAttribute('data-discount-ready') === 'true') return;
        wrap.setAttribute('data-discount-ready', 'true');

        var input = wrap.querySelector('[data-discount-code]');
        var submit = wrap.querySelector('[data-discount-submit]');
        var message = wrap.querySelector('[data-discount-message]');
        var submitLabel = submit ? (submit.textContent || 'Apply').trim() : 'Apply';

        function setMessage(text, type) {
          if (!message) return;
          if (!text) { message.style.display = 'none'; message.textContent = ''; return; }
          message.textContent = text;
          message.style.color = (type === 'error') ? '#f4a09a' : ACCENT;
          message.style.display = 'block';
        }

        function applyDiscount() {
          var code = input ? input.value.trim() : '';
          if (!code) { if (input) input.focus(); return; }

          // Keep any already-applied codes and add the new one (Shopify replaces the whole set).
          var codes = [];
          document.querySelectorAll('[data-discount-remove]').forEach(function (b) {
            var c = (b.getAttribute('data-discount-remove') || '').trim();
            if (c) codes.push(c);
          });
          if (!codes.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) {
            codes.push(code);
          }

          setMessage('', null);
          if (submit) { submit.disabled = true; submit.textContent = 'Applying...'; }

          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ discount: codes.join(',') })
          }).then(function (r) { return r.json(); })
            .then(function (cart) {
              var entry = (cart.discount_codes || []).filter(function (d) {
                return d && d.code && d.code.toLowerCase() === code.toLowerCase();
              })[0];
              if (entry && entry.applicable) {
                window.location.reload();
              } else {
                if (submit) { submit.disabled = false; submit.textContent = submitLabel; }
                setMessage('"' + code + '" is not a valid discount code.', 'error');
                if (input) { input.focus(); input.select(); }
              }
            })
            .catch(function () {
              if (submit) { submit.disabled = false; submit.textContent = submitLabel; }
              setMessage('Something went wrong. Please try again.', 'error');
            });
        }

        if (submit) submit.addEventListener('click', applyDiscount);
        if (input) {
          input.addEventListener('keydown', function (event) {
            if (event.key === 'Enter') {
              event.preventDefault();
              applyDiscount();
            }
          });
        }
      });
    }

    initDiscountForms(document);

    /* ---------- Cart: remove an applied discount code ---------- */
    function initDiscountRemovers(root) {
      (root || document).querySelectorAll('[data-discount-remove]').forEach(function (btn) {
        if (btn.getAttribute('data-remove-ready') === 'true') return;
        btn.setAttribute('data-remove-ready', 'true');

        btn.addEventListener('click', function (event) {
          event.preventDefault();
          var code = (btn.getAttribute('data-discount-remove') || '').trim();

          // Re-apply every other applied code; an empty string clears all.
          var keep = [];
          document.querySelectorAll('[data-discount-remove]').forEach(function (other) {
            var oc = (other.getAttribute('data-discount-remove') || '').trim();
            if (oc && oc.toLowerCase() !== code.toLowerCase()) keep.push(oc);
          });

          btn.disabled = true;
          btn.style.opacity = '0.5';
          btn.textContent = 'Removing...';

          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ discount: keep.join(',') })
          }).then(function () { window.location.reload(); })
            .catch(function () { window.location.reload(); });
        });
      });
    }

    initDiscountRemovers(document);

    /* ---------- Mobile nav drawer ---------- */
    var drawer = document.querySelector('[data-drawer]');
    if (drawer) {
      var setDrawer = function (open) {
        drawer.setAttribute('data-open', open ? 'true' : 'false');
        document.body.style.overflow = open ? 'hidden' : '';
      };
      document.querySelectorAll('[data-drawer-open]').forEach(function (b) {
        b.addEventListener('click', function () { setDrawer(true); });
      });
      document.querySelectorAll('[data-drawer-close]').forEach(function (b) {
        b.addEventListener('click', function () { setDrawer(false); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') setDrawer(false);
      });
    }

    /* ---------- Announcement bar dismiss ---------- */
    document.querySelectorAll('[data-announcement]').forEach(function (bar) {
      var id = bar.getAttribute('data-section-id');
      var key = 'zeroo-ann-' + id;
      try { if (id && localStorage.getItem(key) === '1') { bar.style.display = 'none'; } } catch (e) {}
      var btn = bar.querySelector('[data-ann-dismiss]');
      if (btn) {
        btn.addEventListener('click', function () {
          bar.style.display = 'none';
          try { localStorage.setItem(key, '1'); } catch (e) {}
        });
      }
    });

    /* ---------- Countdown timers ---------- */
    function pad2(n) { return (n < 10 ? '0' : '') + n; }
    function initCountdowns(root) {
      (root || document).querySelectorAll('[data-countdown]').forEach(function (el) {
        if (el.getAttribute('data-cd-ready') === 'true') return;
        var raw = el.getAttribute('data-deadline');
        if (!raw) return;
        var deadline = new Date(raw.trim().replace(' ', 'T')).getTime();
        if (isNaN(deadline)) return;
        el.setAttribute('data-cd-ready', 'true');

        var dEl = el.querySelector('[data-cd-days]');
        var hEl = el.querySelector('[data-cd-hours]');
        var mEl = el.querySelector('[data-cd-mins]');
        var sEl = el.querySelector('[data-cd-secs]');
        var expire = el.getAttribute('data-expire') || 'hide-timer';
        var bar = el.closest('[data-announcement]');
        var timer = null;

        function render() {
          var diff = deadline - Date.now();
          if (diff <= 0) {
            if (dEl) dEl.textContent = '00';
            if (hEl) hEl.textContent = '00';
            if (mEl) mEl.textContent = '00';
            if (sEl) sEl.textContent = '00';
            if (timer) clearInterval(timer);
            if (expire === 'hide-bar' && bar) bar.style.display = 'none';
            else if (expire !== 'keep-zero') el.style.display = 'none';
            return;
          }
          var s = Math.floor(diff / 1000);
          var days = Math.floor(s / 86400); s -= days * 86400;
          var hrs = Math.floor(s / 3600); s -= hrs * 3600;
          var mins = Math.floor(s / 60); s -= mins * 60;
          if (dEl) dEl.textContent = pad2(days);
          if (hEl) hEl.textContent = pad2(hrs);
          if (mEl) mEl.textContent = pad2(mins);
          if (sEl) sEl.textContent = pad2(s);
        }
        render();
        timer = setInterval(render, 1000);
      });
    }
    initCountdowns(document);

    /* ---------- Market / currency selector ---------- */
    function initLocalization(root) {
      (root || document).querySelectorAll('[data-localization-select]').forEach(function (sel) {
        if (sel.getAttribute('data-loc-ready') === 'true') return;
        sel.setAttribute('data-loc-ready', 'true');
        sel.addEventListener('change', function () {
          if (sel.form) sel.form.submit();
        });
      });
    }
    initLocalization(document);

    /* ---------- Mobile swipe carousels: dots + active sync ---------- */
    function initSwipers(root) {
      (root || document).querySelectorAll('.z-swipe').forEach(function (track) {
        if (track.getAttribute('data-swipe-ready') === 'true') return;
        var cards = Array.prototype.slice.call(track.children);
        if (cards.length < 2) return;
        track.setAttribute('data-swipe-ready', 'true');

        var dots = document.createElement('div');
        dots.className = 'z-swipe-dots';
        cards.forEach(function (card, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'z-swipe-dot';
          dot.setAttribute('aria-label', 'Go to item ' + (i + 1));
          dot.addEventListener('click', function () {
            var delta = card.getBoundingClientRect().left - track.getBoundingClientRect().left;
            track.scrollTo({ left: track.scrollLeft + delta, behavior: 'smooth' });
          });
          dots.appendChild(dot);
        });
        if (track.parentNode) track.parentNode.insertBefore(dots, track.nextSibling);

        var dotEls = Array.prototype.slice.call(dots.children);
        function paint() {
          var trackLeft = track.getBoundingClientRect().left;
          var best = 0, bestDist = Infinity;
          cards.forEach(function (c, i) {
            var d = Math.abs(c.getBoundingClientRect().left - trackLeft);
            if (d < bestDist) { bestDist = d; best = i; }
          });
          dotEls.forEach(function (d, i) { d.setAttribute('data-active', i === best ? 'true' : 'false'); });
        }
        var st;
        track.addEventListener('scroll', function () {
          clearTimeout(st);
          st = setTimeout(paint, 60);
        }, { passive: true });
        paint();
      });
    }
    initSwipers(document);

    /* ---------- Reveal on scroll ---------- */
    var revealObserver = null;
    var designMode = !!(window.Shopify && window.Shopify.designMode);

    function revealWithin(root) {
      if (!document.body.classList.contains('z-anim')) return;

      var els = (root || document).querySelectorAll('[data-reveal]');
      if (!els.length) return;

      if (designMode || !('IntersectionObserver' in window)) {
        els.forEach(function (el) { el.classList.add('z-in'); });
        return;
      }

      if (!revealObserver) {
        revealObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) {
              en.target.classList.add('z-in');
              revealObserver.unobserve(en.target);
            }
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
      }

      els.forEach(function (el) {
        if (!el.classList.contains('z-in')) revealObserver.observe(el);
      });
    }

    revealWithin(document);

    document.addEventListener('shopify:section:load', function (event) {
      initPlanForms(event.target || document);
      initDiscountForms(event.target || document);
      initDiscountRemovers(event.target || document);
      initCountdowns(event.target || document);
      initLocalization(event.target || document);
      initSwipers(event.target || document);
      revealWithin(event.target || document);
    });

    /* ---------- Sticky add-to-cart on scroll ---------- */
    var sticky = document.querySelector('[data-sticky-cart]');
    if (sticky) {
      var onScroll = function () {
        var y = window.scrollY || document.documentElement.scrollTop || 0;
        sticky.style.transform = y > 760 ? 'translateY(0)' : 'translateY(110%)';
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  });
})();
